/** basic.userManage */
export default {
    details_edit: "Изменить",
    pwdRegex: "6 символов: цифры или буквы",
    details_userNewsTitle: "Пользователь",
    details_saveEdit: "Сохранить",
    details_editPawword: "Сменить пароль",
    details_loginName: "Учётная запись",
    details_name: "ФИО",
    details_phone: "Телефон",
    details_sex: "Пол",
    details_roleID: "Роль",
    details_Entity: "Организация",
    details_limitsName: "Права",
    details_createTime: "Создан",
    details_upDateTime: "Обновлён",
    details_WeChatOfficialID: "ID офиц. аккаунта WeChat",
    details_WechatID: "WeChat ID",
    details_isLogin: "Вход разрешён",
    details_Mna: "Муж.",
    details_woman: "Жен.",
    delUser: "Удалить пользователя?",

    details_userSwitchTitle: "Настройки пользователя",
    details_isLoginApp: "Вход в приложение",
    details_isReceivePush: "Push тревог в приложении",
    details_isLoginPc: "Вход с ПК",
    details_isReceiveSMS: "SMS",
    details_isREceivePhon: "Звонки",
    details_isReceiveOfficial: "Push офиц. аккаунта",
    details_isPcAlarmPush: "Тревоги на ПК",
    details_isLoginProgram: "Мини-программа",
    details_appPush: "Push в приложении",
    details_subscribe_GZH: "Подписка на аккаунт",
    details_freeYears: "Бесплатный период (лет)",
    gzhPlan_openState: "Состояние включения",
    gzhPlan_intervalLabel: "Интервал",
    gzhPlan_intervalPla: "Введите целое число от 1 до 24",
    gzhPlan_intervalRequired: "Укажите интервал",
    details_gzhSubscribe: "Push офиц. аккаунта",
    details_query_lower: "Статистика с подчинёнными",
    details_no_query: "Без подчинённых",
    details_query: "С подчинёнными",
    time_interval: "Интервал (часы)",
    time_hourly: "ч.",

    details_loginNamePla: "Учётная запись",
    details_namePla: "ФИО",
    details_phonePla: "Телефон",
    details_sexPla: "Пол",
    details_roleIDPla: "Роль",
    details_EntityPla: "Организация",
    details_limitsNamePla: "Название прав",
    details_WeChatOfficialIDPla: "ID офиц. аккаунта",
    details_WechatIDPla: "WeChat ID",
    details_isLoginPla: "Разрешить вход",

    details_loginNameRule: "Укажите учётную запись",
    details_nameRule: "Укажите имя",
    details_phoneRule: "Укажите телефон",
    details_phoneRuleTwo: "Неверный телефон",
    details_roleNoSp: "Укажите роль",
    details_sexRule: "Укажите пол",
    details_pawword: "Укажите пароль",
    details_pawwordTwo: "Пароль: буквы, цифры, подчёркивание",
    details_login_Name: "Укажите учётную запись",
    details_login_name_two: "Только буквы и цифры",
    details_pawwordThree: "Пароль 6–18 символов",
    details_pawwordFour: "Пароль",
    details_pawwordfive: "Повторите пароль",
    details_pawwordsix: "Пароли не совпадают",
    details_EntityRule: "Укажите организацию",
    details_isLoginRule: "Укажите, разрешён ли вход",

    details_gzhPushRule: "Расписание push",

    details_isLoginAppPla: "Вход в приложение",
    details_isReceivePushPla: "Push в приложении",
    details_isLoginPcPla: "Вход с ПК",
    details_isReceiveSMSPla: "SMS",
    details_isREceivePhonPla: "Звонки",
    details_isReceiveOfficialPla: "Push офиц. аккаунта",
    details_isPcAlarmPushPla: "Тревоги на ПК",
    details_isLoginProgramPla: "Мини-программа",

    details_isLoginAppRule: "Укажите доступ к приложению",
    details_isReceivePushRule: "Укажите push",
    details_isLoginPcRule: "Укажите доступ с ПК",
    details_isReceiveSMSRule: "Укажите SMS",
    details_isREceivePhonRule: "Укажите звонки",
    details_isReceiveOfficialRule: "Укажите push аккаунта",
    details_isPcAlarmPushRule: "Укажите тревоги ПК",
    details_isLoginProgramRule: "Укажите мини-программу",

    details_confimEdit: "Подтвердить",

    user_roleID: "ID роли",
    user_rolePla: "Поиск роли",
    user_sexSearPla: "Пол",
    user_moreSear: "Ещё",
    user_entityNamePla: "Организация",
    user_confirmPaword: "Подтверждение пароля",
    user_addUser: "Новый пользователь",
    user_cipher: "Пароль",
    user_submit: "Отправить",
    user_role: "Роль",
}
